import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FilterByFavoriteFolderPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'filterByFavoriteFolder',
  pure: false
})
export class FilterByFavoriteFolderPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(assets: any[], favoriteId: number): any {
    if (!assets || typeof favoriteId == "undefined") {
      return assets;
    } else {
      return assets.filter(asset => {
        return asset.FavoriteId == favoriteId
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/filter-by-favorite-folder/filter-by-favorite-folder.ts